exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".articleNum{position:absolute;top:100px;right:100px}.articleDetail .campSpan{display:block;text-align:center;float:left;height:36px;padding:0 30px 5px 15px;border:1px solid #999;border-radius:5px;margin:10px;box-sizing:border-box;font-size:12px;position:relative;cursor:pointer}.articleDetail .campContain{width:700px;height:135px;border:1px solid gray;box-sizing:border-box;overflow-y:scroll}.gray{color:#999}.campSpan i{width:20px;height:20px;line-height:20px;color:#999;position:absolute;right:5px;top:5px}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader!./~/vue-loader/lib/style-rewriter.js?id=data-v-64cdf139!./~/vue-loader/lib/selector.js?type=styles&index=0!./src/components/yunying/article/articleDetail.vue
// module id = 557
// module chunks = 0